import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=7ca973ba&scoped=true&"
import script from "./VehicleList.vue?vue&type=script&setup=true&lang=js&"
export * from "./VehicleList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca973ba",
  null
  
)

export default component.exports